import { Descriptions } from "antd";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import { TypeResponsavel } from "../../../../../Models/Domain/Pessoa/Responsavel";
import Utilitario from "../../../../../Utils/Utilitario";
import { EnumTipoDeDocumento } from "../../../../../Models/Domain/Pessoa/Enum";

export const DescricaoDoResponsavel: React.FC<{responsavel: TypeResponsavel, ocultarTitulo?: boolean}> = (props) => {
    const responsavel = props.responsavel
    return <Descriptions
        bordered
        title={props.ocultarTitulo ? undefined : "Responsável"}
        column={1}
        items={[
            {
                key: "nome",
                label: "Nome",
                children: responsavel.pessoa?.nome ?? "N/A"
            },
            {
                key: "cpf",
                label: "CPF",
                children: Formatacoes.formatarCPF(responsavel.pessoa?.cpf) ?? "N/A"
            },
            {
                key: "documento",
                label: Utilitario.enumParaString(EnumTipoDeDocumento, responsavel.tipoDeDocumento) ?? "Documento",
                children: responsavel.documento ?? "N/A"
            },
            {
                key: "telefone",
                label: "Telefone",
                children: ((): string => {
                    const telefone = responsavel.pessoa?.telefones?.find((t) => t.principal == true) ??  responsavel.pessoa?.telefones?.at(0);
                    if(telefone == undefined) return "N/A"

                    return `(${telefone.ddd}) ${telefone.numero}`
                })()
            },
            {
                key: "email",
                label: "E-mail",
                children: ((): string => {
                    const email = responsavel.pessoa?.emails?.find((e) => e.principal == true) ??  responsavel.pessoa?.emails?.at(0);
                    if(email == undefined) return "N/A"

                    return `${email.endereco}`
                })()
            },
            {
                key: "endereco",
                label: "Endereço",
                children: responsavel.pessoa?.enderecos?.at(0) ?
                    Formatacoes.formatarEndereco(responsavel.pessoa.enderecos.at(0)!) : "N/A"
            },
        ]}
    />
}
